// extracted by mini-css-extract-plugin
export default {"container":"CitiesPage_container__9xKBV","loadingContainer":"CitiesPage_loadingContainer__w6AD8"};